module.exports = __webpack_public_path__ + "static/media/sotyktu_android_pass.dc5eb2d9.png";